import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import SubscriptionList from "../partials/list/SubscriptionList";
import { BoxContainer } from '../layouts/Theme';
import { useFlow } from '../context/FlowContext';
import { useI18N } from '../context/I18NContext';
import { useConsumerSubscriptions } from '../hooks/query/useConsumerSubscriptions';
export default function Subscriptions(props) {
    var _a, _b, _c;
    const { t } = useI18N();
    const flow = useFlow();
    // this view is outside the flow, so there is no step to take a label from: it puts its own
    // title in the app bar
    const title = t('Strippenkaarten en abonnementen');
    useEffect(() => {
        var _a;
        (_a = flow.setTitle) === null || _a === void 0 ? void 0 : _a.call(flow, title);
    }, [title]);
    const subscriptionsQuery = useConsumerSubscriptions();
    // the same three states the appointments view has: still loading, failed, or the list
    const result = subscriptionsQuery.data;
    const failed = ((_a = result === null || result === void 0 ? void 0 : result.status) === null || _a === void 0 ? void 0 : _a.status) === 'failed';
    const subscriptions = failed ? undefined : (_c = (_b = result === null || result === void 0 ? void 0 : result.result) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.subscriptions;
    return (_jsxs(BoxContainer, { children: [subscriptionsQuery.isFetching && !result && (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', my: 4 }, children: _jsx(CircularProgress, {}) })), (subscriptionsQuery.isError || failed) && (_jsx(Alert, { sx: { my: 1 }, severity: "error", children: failed ? t(result.status.message) : t('Je strippenkaarten en abonnementen konden niet worden opgehaald.') })), subscriptions && (_jsx(SubscriptionList, { subscriptions: subscriptions }))] }));
}
